import { RouteObject } from "react-router"
import { FuncionarioList } from "./funcionario.view"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { Badge } from "@mui/icons-material"

export enum PathRotaFuncionario {
    funcionario = "/funcionario"
}

const routerFuncionario: RouteObject = {
    path: PathRotaFuncionario.funcionario,
    element: <FuncionarioList/>,
}


export const navigationToFuncionarioView = ()=> rotas.navigate(PathRotaFuncionario.funcionario)

export function startRouterFuncionario(){
    const menu:MainMenu = {
        text:"Funcionarios",
        icon:<Badge />,
        eventOnClick:navigationToFuncionarioView
    }
    menuRotas.push(menu);
    return routerFuncionario
}